import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BalanceItem, FormattedExplanation, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-fva',
  templateUrl: './spec-fva.component.html',
  imports: [
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./spec-fva.component.scss']
})
export class SpecFvaComponent implements OnInit, OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public financialAssetsFg = {} as FormGroup;
  public investmentsInParticipatingInterestsInGroupCompaniesFg = {} as FormGroup;
  public investmentsInParticipatingInterestsOtherFg = {} as FormGroup;
  public investmentsOtherAffiliatedCompaniesFg = {} as FormGroup;
  public receivablesGroupCompaniesNoncurrentFg = {} as FormGroup;
  public receivablesOtherAffiliatedCompaniesNoncurrentFg = {} as FormGroup;
  public receivablesShareholdersParticipatingInterestsNoncurrentFg = {} as FormGroup;
  public securitiesOtherNoncurrentFg = {} as FormGroup;
  public receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg = {} as FormGroup;
  public receivablesOtherNoncurrentFg = {} as FormGroup;
  public deferredTaxAssetsNoncurrentFg = {} as FormGroup;
  public financialAssetsOtherFg = {} as FormGroup;

  public financialAssetsDisclosureFg = {} as FormGroup;
  public investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg = {} as FormGroup;
  public investmentsInParticipatingInterestsOtherDisclosureFg = {} as FormGroup;
  public investmentsOtherAffiliatedCompaniesDisclosureFg = {} as FormGroup;
  public receivablesGroupCompaniesNoncurrentDisclosureFg = {} as FormGroup;
  public receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg = {} as FormGroup;
  public receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg = {} as FormGroup;
  public securitiesOtherNoncurrentDisclosureFg = {} as FormGroup;
  public receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg = {} as FormGroup;
  public receivablesOtherNoncurrentDisclosureFg = {} as FormGroup;
  public deferredTaxAssetsNoncurrentDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.financialAssetsFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.investmentsInParticipatingInterestsInGroupCompaniesFg = this.jrDataService.createFormGroupBalanceItem();
    this.investmentsInParticipatingInterestsOtherFg = this.jrDataService.createFormGroupBalanceItem();
    this.investmentsOtherAffiliatedCompaniesFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesGroupCompaniesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesOtherAffiliatedCompaniesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesShareholdersParticipatingInterestsNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.securitiesOtherNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesOtherNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.deferredTaxAssetsNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.financialAssetsOtherFg = this.jrDataService.createFormGroupBalanceItem();
    this.financialAssetsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentsInParticipatingInterestsOtherDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentsOtherAffiliatedCompaniesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesGroupCompaniesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.securitiesOtherNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesOtherNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.deferredTaxAssetsNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const financieleVasteActiva = value.rapportage?.jaarrekeningen?.at(0)?.balans?.financieleVasteActiva;

    if (financieleVasteActiva) {
      this.financialAssetsFg.reset();

      if (financieleVasteActiva.financialAssets) {
        this.financialAssetsFg.patchValue(financieleVasteActiva.financialAssets, {emitEvent: false})
      }

      const uitsplitsing = financieleVasteActiva.financieleVasteActivaUitsplitsing;
      const tekstueel = financieleVasteActiva.financieleVasteActivaTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.investmentsInParticipatingInterestsInGroupCompanies) {
          const subItem = uitsplitsing.investmentsInParticipatingInterestsInGroupCompanies;
          this.investmentsInParticipatingInterestsInGroupCompaniesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.investmentsInParticipatingInterestsInGroupCompaniesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.investmentsInParticipatingInterestsOther) {
          const subItem = uitsplitsing.investmentsInParticipatingInterestsOther;
          this.investmentsInParticipatingInterestsOtherFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.investmentsInParticipatingInterestsOtherFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.investmentsOtherAffiliatedCompanies) {
          const subItem = uitsplitsing.investmentsOtherAffiliatedCompanies;
          this.investmentsOtherAffiliatedCompaniesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.investmentsOtherAffiliatedCompaniesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesGroupCompaniesNoncurrent) {
          const subItem = uitsplitsing.receivablesGroupCompaniesNoncurrent;
          this.receivablesGroupCompaniesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesGroupCompaniesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesOtherAffiliatedCompaniesNoncurrent) {
          const subItem = uitsplitsing.receivablesOtherAffiliatedCompaniesNoncurrent;
          this.receivablesOtherAffiliatedCompaniesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesOtherAffiliatedCompaniesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesShareholdersParticipatingInterestsNoncurrent) {
          const subItem = uitsplitsing.receivablesShareholdersParticipatingInterestsNoncurrent;
          this.receivablesShareholdersParticipatingInterestsNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesShareholdersParticipatingInterestsNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.securitiesOtherNoncurrent) {
          const subItem = uitsplitsing.securitiesOtherNoncurrent;
          this.securitiesOtherNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.securitiesOtherNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrent) {
          const subItem = uitsplitsing.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrent;
          this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesOtherNoncurrent) {
          const subItem = uitsplitsing.receivablesOtherNoncurrent;
          this.receivablesOtherNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesOtherNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.deferredTaxAssetsNoncurrent) {
          const subItem = uitsplitsing.deferredTaxAssetsNoncurrent;
          this.deferredTaxAssetsNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.deferredTaxAssetsNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.financialAssetsOther) {
          const subItem = uitsplitsing.financialAssetsOther;
          this.financialAssetsOtherFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.financialAssetsOtherFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.financialAssetsDisclosure) {
          this.financialAssetsDisclosureFg.patchValue(tekstueel.financialAssetsDisclosure);
        }
        if (tekstueel.investmentsInParticipatingInterestsInGroupCompaniesDisclosure) {
          this.investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg.patchValue(tekstueel.investmentsInParticipatingInterestsInGroupCompaniesDisclosure);
        }
        if (tekstueel.investmentsInParticipatingInterestsOtherDisclosure) {
          this.investmentsInParticipatingInterestsOtherDisclosureFg.patchValue(tekstueel.investmentsInParticipatingInterestsOtherDisclosure);
        }
        if (tekstueel.investmentsOtherAffiliatedCompaniesDisclosure) {
          this.investmentsOtherAffiliatedCompaniesDisclosureFg.patchValue(tekstueel.investmentsOtherAffiliatedCompaniesDisclosure);
        }
        if (tekstueel.receivablesGroupCompaniesNoncurrentDisclosure) {
          this.receivablesGroupCompaniesNoncurrentDisclosureFg.patchValue(tekstueel.receivablesGroupCompaniesNoncurrentDisclosure);
        }
        if (tekstueel.receivablesOtherAffiliatedCompaniesNoncurrentDisclosure) {
          this.receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.patchValue(tekstueel.receivablesOtherAffiliatedCompaniesNoncurrentDisclosure);
        }
        if (tekstueel.receivablesShareholdersParticipatingInterestsNoncurrentDisclosure) {
          this.receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.patchValue(tekstueel.receivablesShareholdersParticipatingInterestsNoncurrentDisclosure);
        }
        if (tekstueel.securitiesOtherNoncurrentDisclosure) {
          this.securitiesOtherNoncurrentDisclosureFg.patchValue(tekstueel.securitiesOtherNoncurrentDisclosure);
        }
        if (tekstueel.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosure) {
          this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg.patchValue(tekstueel.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosure);
        }
        if (tekstueel.receivablesOtherNoncurrentDisclosure) {
          this.receivablesOtherNoncurrentDisclosureFg.patchValue(tekstueel.receivablesOtherNoncurrentDisclosure);
        }
        if (tekstueel.deferredTaxAssetsNoncurrentDisclosure) {
          this.deferredTaxAssetsNoncurrentDisclosureFg.patchValue(tekstueel.deferredTaxAssetsNoncurrentDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst!.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst![i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst![i])
          formArray.push(formGroup);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.financialAssetsFg.updateValueAndValidity();
    this.investmentsInParticipatingInterestsInGroupCompaniesFg.updateValueAndValidity();
    this.investmentsInParticipatingInterestsOtherFg.updateValueAndValidity();
    this.investmentsOtherAffiliatedCompaniesFg.updateValueAndValidity();
    this.receivablesGroupCompaniesNoncurrentFg.updateValueAndValidity();
    this.receivablesOtherAffiliatedCompaniesNoncurrentFg.updateValueAndValidity();
    this.receivablesShareholdersParticipatingInterestsNoncurrentFg.updateValueAndValidity();
    this.securitiesOtherNoncurrentFg.updateValueAndValidity();
    this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg.updateValueAndValidity();
    this.receivablesOtherNoncurrentFg.updateValueAndValidity();
    this.deferredTaxAssetsNoncurrentFg.updateValueAndValidity();
    this.financialAssetsOtherFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          financieleVasteActiva: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.financieleVasteActiva,
            financieleVasteActivaUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.financieleVasteActiva?.financieleVasteActivaUitsplitsing,
              investmentsInParticipatingInterestsInGroupCompanies: this.investmentsInParticipatingInterestsInGroupCompaniesFg.value,
              investmentsInParticipatingInterestsOther: this.investmentsInParticipatingInterestsOtherFg.value,
              investmentsOtherAffiliatedCompanies: this.investmentsOtherAffiliatedCompaniesFg.value,
              receivablesGroupCompaniesNoncurrent: this.receivablesGroupCompaniesNoncurrentFg.value,
              receivablesOtherAffiliatedCompaniesNoncurrent: this.receivablesOtherAffiliatedCompaniesNoncurrentFg.value,
              receivablesShareholdersParticipatingInterestsNoncurrent: this.receivablesShareholdersParticipatingInterestsNoncurrentFg.value,
              securitiesOtherNoncurrent: this.securitiesOtherNoncurrentFg.value,
              receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrent: this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg.value,
              receivablesOtherNoncurrent: this.receivablesOtherNoncurrentFg.value,
              deferredTaxAssetsNoncurrent: this.deferredTaxAssetsNoncurrentFg.value,
              financialAssetsOther: this.financialAssetsOtherFg.value,
            },
            financieleVasteActivaTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.financieleVasteActiva?.financieleVasteActivaTekstueel,
              financialAssetsDisclosure: this.financialAssetsDisclosureFg.value,
              investmentsInParticipatingInterestsInGroupCompaniesDisclosure: this.investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg.value,
              investmentsInParticipatingInterestsOtherDisclosure: this.investmentsInParticipatingInterestsOtherDisclosureFg.value,
              investmentsOtherAffiliatedCompaniesDisclosure: this.investmentsOtherAffiliatedCompaniesDisclosureFg.value,
              receivablesGroupCompaniesNoncurrentDisclosure: this.receivablesGroupCompaniesNoncurrentDisclosureFg.value,
              receivablesOtherAffiliatedCompaniesNoncurrentDisclosure: this.receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.value,
              receivablesShareholdersParticipatingInterestsNoncurrentDisclosure: this.receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.value,
              securitiesOtherNoncurrentDisclosure: this.securitiesOtherNoncurrentDisclosureFg.value,
              receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosure: this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg.value,
              receivablesOtherNoncurrentDisclosure: this.receivablesOtherNoncurrentDisclosureFg.value,
              deferredTaxAssetsNoncurrentDisclosure: this.deferredTaxAssetsNoncurrentDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }

}
